import { render, staticRenderFns } from "./DiagnosticAppointmentSurvey.vue?vue&type=template&id=312269af"
import script from "./DiagnosticAppointmentSurvey.vue?vue&type=script&lang=js"
export * from "./DiagnosticAppointmentSurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports